import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", amount = 0.15 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const MaskedLines = ({ lines, className = "", delay = 0, animate = false }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="-mb-[0.1em] block overflow-hidden pb-[0.1em]">
        <motion.span
          className="block will-change-transform"
          initial={{ y: "115%" }}
          {...(animate
            ? { animate: { y: 0 } }
            : { whileInView: { y: 0 }, viewport: { once: true, amount: 0.4 } })}
          transition={{ duration: 1.1, delay: delay + i * 0.13, ease: EASE }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);
